import styled from 'styled-components';
import { colors } from '../../styles';
import { Loader } from 'semantic-ui-react';

// sizes copied from semantic UI
const sizes = {
  mini: 0.875,
  tiny: 1,
  small: 1.5,
  medium: 2,
  large: 3,
  big: 3.25,
  huge: 3.625,
  massive: 4
};

export default styled(Loader)`
  @keyframes circle {
    0% {
      stroke-dashoffset: 300;
    }
    50% {
      stroke-dashoffset: 0;
      transform: rotate(180deg);
    }
    100% {
      stroke-dashoffset: -300;
      transform: rotate(360deg);
    }
  }

  padding-top: 0 !important;
  &:before,
  &:after {
    display: none;
  }

  /* namespaced */
  .loader {
    &__circle {
      circle {
        fill: transparent;
        stroke: ${colors.primary};
        stroke-width: 10;
        stroke-linecap: round;
        stroke-dasharray: 300;
        stroke-dashoffset: 300;
        animation: circle 2s linear infinite;
        transform-origin: center center;
      }
    }
  }

  &.loader {
    /* Sizes */
    ${({ size }) => `
      &.${size} .loader__circle {
        width: ${sizes[size]}rem;
        height: ${sizes[size]}rem;
      }
    `}
  }
`;
